import { useEffect, useState } from "react";
import { Button, IconButton, InputLabel, Switch, TextField } from "@mui/material";
import { Image as ImageIcon } from '@mui/icons-material'
import { useForm } from 'react-hook-form'
import { yupResolver } from "@hookform/resolvers/yup";
import { ValidationSchemaVariant } from "../services/schemaValidation";
import { ValidateErrorMessage } from "components/ValidateErrorMessage";
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import DialogMenuImageManager from "routes/ImageManager/DialogMenuImageManager";

export default function Form({ open, mode, menu, instance, close, addAction, editAction }) {
  const [dataInstance, setDataInstance] = useState({})
  const [imageManagerModalOpen, setImageManagerModalOpen] = useState(false)
  const [dataFieldImageManager, setDataFieldImageManager] = useState(null)
  let { reset, handleSubmit, register, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(ValidationSchemaVariant)
  })

  useEffect(() => {
    if (open) {
      if (mode === 1) {
        setDataInstance(instance)
        reset(instance)
      }
    }
    //eslint-disable-next-line
  }, [open])

  const handleClose = () => { reset(); setDataInstance({}); close() }

  const handlerActions = (params) => {
    if (mode === 0) {
      addAction(params)
    } else {
      editAction(params)
    }
    handleClose()
  }

  const handleOnChangeData = (event) => {
    if (event.target.name.includes(".")) {
      const separate = event.target.name.split(".")
      setDataInstance({ ...dataInstance, [separate[0]]: { ...dataInstance[separate[0]], [separate[1]]: event.target.value } })
      return;
    }
    setDataInstance({ ...dataInstance, [event.target.name]: event.target.value })
  }

  const handleChangeBoolean = (name) => {
    setDataInstance({ ...dataInstance, [name]: !dataInstance[name] })
  }

  /*Handlers Image manager */
  const handleOpenImageManager = () => { setImageManagerModalOpen(true) }
  const handleCloseImageManager = (prop) => { setImageManagerModalOpen(prop) }
  const handleFieldImageManager = (prop) => { setDataFieldImageManager(prop) }
  const handleSelectImageManager = (url) => {
    setDataInstance({ ...dataInstance, [dataFieldImageManager]: url })
    setValue(dataFieldImageManager, url)
  }

  const Actions = () => (<>
    <Button onClick={handleClose}>Cancel</Button>
    <Button variant="contained" color="info" onClick={handleSubmit(handlerActions)}>{mode === 0 ? "Agregar" : "Editar"}</Button>
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={mode === 0 ? "Agregar variante" : "Editar variante"} actions={<Actions />}>
      <>
        <InputLabel htmlFor='name' required style={{ fontSize: 14 }}>Nombre</InputLabel>
        <TextField id='name' fullWidth margin="dense" type="text" name='name' size="small"
          value={dataInstance.name || ""}
          {...register(`name`)}
          error={errors.name ? true : false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.name?.message} />
        <br />
        <InputLabel htmlFor='showName' required style={{ fontSize: 14 }}>Mostrar nombre de la variante?</InputLabel>
        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-showName` }}
          onClick={() => handleChangeBoolean('showName')}
          checked={dataInstance.showName || false}
          {...register(`showName`)}
        />
        <br />
        <InputLabel htmlFor='description' style={{ fontSize: 14 }}>Descripción</InputLabel>
        <TextField id='description' fullWidth margin="dense" type="text" name='description' multiline maxRows={5} size="small"
          value={dataInstance.description || ""}
          {...register(`description`)}
          error={errors.description ? true : false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.description?.message} />
        <br />
        <InputLabel htmlFor='price' style={{ fontSize: 14 }}>Precio</InputLabel>
        <TextField id='price' fullWidth margin="dense" type="number" name='price' size="small"
          value={dataInstance.price || ""}
          {...register(`price`)}
          error={errors.price ? true : false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.price?.message} />
        <br />
        <InputLabel htmlFor='calories' style={{ fontSize: 14 }}>Calorias</InputLabel>
        <TextField id='calories' fullWidth margin="dense" type="number" name='calories' size="small"
          value={dataInstance.calories || ""}
          {...register(`calories`)}
          error={errors.calories ? true : false}
          onChange={handleOnChangeData} />
        <ValidateErrorMessage message={errors.calories?.message} />
        <br />
        <div style={{ display: "grid", gridTemplateColumns: "40% 60%" }}>
          <div style={{ textAlign: "center" }}>
            <img src={dataInstance.image || ""} style={{ width: "90%" }} alt="form-img" />
          </div>
          <div>
            <InputLabel htmlFor='image' required style={{ fontSize: 14 }}>Imagen</InputLabel>
            <TextField id='image' fullWidth margin="dense" type="text" name='image' size="small"
              value={dataInstance.image || ""}
              {...register(`image`)} error={errors.image ? true : false}
              onChange={handleOnChangeData} />
            <ValidateErrorMessage message={errors.image?.message} />
            <IconButton onClick={() => { handleFieldImageManager('image'); handleOpenImageManager(); }}><ImageIcon /></IconButton>
          </div>
        </div>
        <br />
        <InputLabel htmlFor='showImage' required style={{ fontSize: 14 }}>Mostrar imagen?</InputLabel>
        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-showImage` }}
          onClick={() => handleChangeBoolean('showImage')}
          checked={dataInstance.showImage || false}
          {...register(`showImage`)}
        />
        <br />
        <InputLabel htmlFor='active' required style={{ fontSize: 14 }}>Está activa?</InputLabel>
        <Switch edge="end" inputProps={{ 'aria-labelledby': `switch-list-label-active` }}
          onClick={() => handleChangeBoolean('active')}
          checked={dataInstance.active || false}
          {...register(`active`)}
        />
      </>
    </FlexibleWidthDialog>
    <DialogMenuImageManager
      open={imageManagerModalOpen}
      menu={menu}
      actionClose={handleCloseImageManager}
      setImageSelected={handleSelectImageManager} />
  </>)
}